export default __webpack_public_path__ + "static/media/ticket-sold-new.75410568.svg";